import{createPluginCenter as e,request as t,markdown as n}from"@topwrite/core";export{BaseConfig,Book,Config,File,LetterAvatar,Level,Summary,SummaryArticle,SummaryPart,aes,isEncryptedData,isRequestError,isUrl,markdown,md5,pluginCenter,request}from"@topwrite/core";import r from"url";import{jsx as o,Fragment as i,jsxs as s}from"react/jsx-runtime";import a,{Suspense as c,Fragment as l,Component as d,useMemo as u,createElement as h,useState as m,useEffect as p,useCallback as f,createContext as g,useContext as v,useRef as w,Children as b,forwardRef as y,useImperativeHandle as x}from"react";import k from"@babel/runtime/helpers/defineProperty";import{useSelector as C,Model as S,createStore as $,Provider as E,useActions as D}from"@topthink/redux-model";export{Model}from"@topthink/redux-model";import I from"loadjs";export{default as loadjs}from"loadjs";import P from"query-string";import{noop as T,debounce as M,throttle as z}from"lodash";import j,{createGlobalStyle as L,StyleSheetManager as A}from"styled-components";export{ThemeProvider,createGlobalStyle,css,keyframes,default as styled}from"styled-components";import{HelmetProvider as _}from"react-helmet-async";export{Helmet}from"react-helmet-async";import{createIntlCache as O,createIntl as U,RawIntlProvider as N}from"react-intl";export{IntlContext,defineMessage,defineMessages,useIntl}from"react-intl";import{toc as W}from"mdast-util-toc";import H from"remark-slug";import{all as q,toHast as B}from"mdast-util-to-hast";import{convert as F}from"unist-util-is";import R from"html-tags";import{toString as V}from"mdast-util-to-string";import G from"react-dom";export{default as useEvent}from"@react-hook/event";export{useHotkeys}from"react-hotkeys-hook";export{useAsync,useAsyncCallback,useAsyncFetchMore}from"react-async-hook";window.TopWritePlugins={};class J extends HTMLElement{connectedCallback(){this.addEventListener("click",(e=>{if(e.preventDefault(),!this.isContentEditable){const e=this.attributes.getNamedItem("src");let t=e?.value;if(t){let e=document.createElement("a");e.download=this.textContent||"",e.style.display="none",e.target="_blank",e.href=r.resolve(location.href,t),document.body.appendChild(e),e.click(),document.body.removeChild(e)}}}))}}function K(e){let{component:t,defaultComponent:n=l,props:r,children:i=null,context:s}=e;return null===t?null:o(c,{fallback:null,children:o(t,{props:r,Component:n,context:s,children:i})})}customElements.define("t-attachment",J);class Q extends d{constructor(){super(...arguments),k(this,"state",{hasError:!1})}componentDidCatch(){this.setState({hasError:!0})}render(){return this.state.hasError?null:this.props.children}}var X=(e,t)=>e.filter((e=>{let{descriptor:n}=e;return t===n.role})).sort(((e,t)=>{let{descriptor:{priority:n=0}}=e,{descriptor:{priority:r=0}}=t;return n-r})).map((e=>{return t=e.Component,e=>o(Q,{children:o(t,{...e},"WrappedComponent")});var t}));function Y(e){let{component:t,props:n}=e;return h(t,n)}function Z(e){let{props:t,role:n,component:r,context:i}=e;const s=r?o(Y,{component:r,props:t,context:i}):null,a=C("components");return u((()=>X(a,n)),[a,n]).reduce(((e,n)=>o(K,{defaultComponent:r,component:n,props:t,context:i,children:e})),s)}function ee(e){let{props:t,component:n,role:r,context:s}=e;const a=C("components"),c=u((()=>X(a,r)),[a,r]);return o(i,{children:c.map(((e,r)=>o(K,{defaultComponent:n,component:e,props:t,context:s},r)))})}async function te(e){let t=`topwrite-plugin-${e.name}`;if(!I.isDefined(t)){let n=`${e.host}/${e.main}`;try{await I(n,t,{returnPromise:!0})}catch{console.warn(`插件${e.name}加载失败`)}}}function ne(e,t){let n;return n=t instanceof Array?{Component:t[0],descriptor:{role:e,...t[1]}}:{Component:t,descriptor:{role:e}},n}const re="localStorage";function oe(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:re;if("undefined"==typeof window)throw new Error("Browser storage is not available on NodeJS / TopWrite SSR process");if("none"===e)return null;try{return window[e]}catch(e){return null}}const ie={get:()=>null,set:()=>{},del:()=>{}},se=(e,t)=>{const n=oe(t?.persistence);return null===n?ie:{get:()=>n.getItem(e),set:t=>n.setItem(e,t),del:()=>n.removeItem(e)}};function ae(){const e=oe(arguments.length>0&&void 0!==arguments[0]?arguments[0]:re);if(!e)return[];const t=[];for(let n=0;n<e.length;n+=1){const r=e.key(n);null!==r&&t.push(r)}return t}function ce(){const e=C("book");if(!e)throw new Error("book object not initialized");return e}function le(){const{config:e}=ce();return e.getValue("themeConfig")}const de="light",ue="dark";function he(e){document.documentElement.setAttribute("data-theme",e)}const me=e=>{const t=ce(),n=u((()=>se(`${e}.${t.id}.theme`)),[t.id,e]),{defaultMode:r}=le(),[o,i]=m((()=>{const e=(e=>e===ue?ue:de)(n.get()||r);return he(e),e}));p((()=>{he(o)}),[o]);const s=f((()=>{i(de),n.set(de)}),[n]),a=f((()=>{i(ue),n.set(ue)}),[n]);return{isDarkTheme:o===ue,setLightTheme:s,setDarkTheme:a}},pe=g(void 0);function fe(e){let{children:t,context:n}=e;const{isDarkTheme:r,setLightTheme:i,setDarkTheme:s}=me(n);return o(pe.Provider,{value:{isDarkTheme:r,setLightTheme:i,setDarkTheme:s},children:t})}function ge(){const e=v(pe);return null==e?{isDarkTheme:!1,setLightTheme:T,setDarkTheme:T}:e}const ve=L`

  //TODO 转移到异步加载
  //附件
  t-attachment {
    color: var(--ttw-primary-color, #3c60ff);
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
    padding: 0 4px;
    vertical-align: bottom;
    margin: 0 1px;

    &:before {
      content: '';
      width: 18px;
      height: 18px;
      background-color: var(--ttw-primary-color, #3c60ff);
      mask: url("${"data:image/svg+xml,%3csvg t='1642406480574' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2254' width='16' height='16'%3e %3cpath d='M874.666667 467.2c-10.666667-10.666667-29.866667-12.8-42.666667 0l-343.466667 341.333333c-74.666667 74.666667-198.4 74.666667-275.2 0-36.266667-36.266667-57.6-85.333333-57.6-136.533333s19.2-100.266667 57.6-136.533333L556.8 192c46.933333-46.933333 121.6-46.933333 168.533333 0 23.466667 23.466667 34.133333 53.333333 34.133334 83.2 0 32-12.8 61.866667-34.133334 83.2L384 704c-17.066667 17.066667-44.8 17.066667-64 0-8.533333-8.533333-12.8-19.2-12.8-32s4.266667-23.466667 12.8-32l317.866667-315.733333c10.666667-10.666667 12.8-29.866667 0-42.666667-10.666667-12.8-29.866667-12.8-42.666667 0L277.333333 597.333333c-19.2 19.2-29.866667 46.933333-29.866666 74.666667S258.133333 725.333333 277.333333 746.666667c40.533333 40.533333 106.666667 40.533333 147.2 0L768 403.2c34.133333-34.133333 53.333333-78.933333 53.333333-125.866667s-19.2-93.866667-53.333333-125.866666a178.986667 178.986667 0 0 0-253.866667 0l-341.333333 341.333333c-46.933333 46.933333-74.666667 110.933333-74.666667 179.2s25.6 132.266667 74.666667 179.2c49.066667 49.066667 115.2 74.666667 179.2 74.666667s130.133333-25.6 179.2-74.666667l343.466667-341.333333c10.666667-12.8 10.666667-32 0-42.666667z' p-id='2255'%3e%3c/path%3e%3c/svg%3e"}") no-repeat center;
      margin-right: 4px;
    }

    &:after {
      content: "(" attr(size) ")";
      margin-left: 4px;
      display: none;
    }

    &[size]:after {
      display: inline;
    }

    &:hover {
      background: rgba(0, 0, 0, .1);
    }

    &:read-write {
      cursor: text;
    }
  }
`;const we=new class extends S{constructor(){super(...arguments),k(this,"initialState",[])}*register(e){yield this.setState((t=>t.push(e)))}};const be=new class extends S{};var ye=Object.freeze({__proto__:null,components:we,options:be});function xe(e,t,n){const r="function"==typeof t;r||(n=t),p((()=>{let n;const o=e();return Promise.resolve(o).then((e=>{n=e})),()=>{r&&t(n)}}),n)}function ke(e){return e.__esModule&&e.default?e.default:e}const Ce=g(void 0),Se=()=>{const e=v(Ce);if(void 0===e)throw new Error("useIntlContext must be used within a Layout component");return e},$e=e=>{let{localize:t,children:n}=e;const{addMessages:r}=Se(),[s,a]=m(!0);return xe((async()=>{a(!0),await r(t),a(!1)}),[t]),s?null:o(i,{children:n})},Ee=e=>{let{children:t}=e;const{locale:n,messages:r}=Se(),i=u((()=>{const e=O();return U({locale:n,messages:r,defaultLocale:"en"},e)}),[n,r]);return o(N,{value:i,children:t})},De=e=>{let{children:t,locale:n,messages:r}=e;const[i,s]=m(r);return o(Ce.Provider,{value:{locale:n,messages:i,addMessages:async e=>{s(Object.assign({},i,ke(await e(n))))}},children:o(Ee,{children:t})})};class Ie{constructor(e,t,n){k(this,"name",void 0),k(this,"book",void 0),k(this,"models",{...ye}),k(this,"components",[]),k(this,"activates",[]),k(this,"plugins",[]),k(this,"initialState",void 0),this.name=e,this.book=t,this.initialState=n}registerComponents(e,t){for(let[n,r]of Object.entries(e))r&&("plugin:setting"===n&&(n=`plugin:setting:${t}`),this.components.push(ne(n,r)))}registerModels(e,t){for(const[n,r]of Object.entries(e))t?this.models[`@${t}@${n}`]=r:this.models[n]=r}async registerPlugins(e){this.plugins=e;for(const t of e)try{this.registerComponents(t.components,t.name),this.registerModels(t.models,t.name),t.activate&&this.activates.push(t.activate),t.register&&await t.register(this.name,this.book)}catch(e){console.log(e)}}async createApp(e){const t=navigator.language,n=await this.loadMessages(t,e),r=$(this.models,{book:this.book,components:this.components,...this.initialState}),a=e=>{let{children:t}=e;return o(i,{children:t})},c=e=>{let{children:t}=e;const n=o(Z,{role:`activate:${this.name}`,props:{children:t,name:this.name},component:a});return this.activates.reduce(((e,t)=>{const n=t(this.name);return void 0!==n?o(i,{children:n}):e}),n)};return e=>{let{children:i}=e;return o(E,{store:r,children:o(_,{children:s(fe,{context:this.name,children:[o(ve,{}),o(De,{locale:t,messages:n,children:o(c,{children:i})})]})})})}}async loadMessages(e,t){return await this.plugins.reduce((async(t,n)=>{const r=ke(await t);return n.localize?Object.assign({},r,ke(await n.localize(e))):r}),t(e))}}async function Pe(n,r,o,i,s,a){const c=await async function(n,r){let o=[];if(r){const t=e(r);try{o=await t.getInstalled(n),o=o.filter((e=>!window.TopWritePlugins[e.name]?.meta))}catch{}}try{const e=sessionStorage.getItem("PLUGIN_DEV"),n=P.parse(window.location.search);if("dev"in n||e){const r=n.dev||e||8080;try{const e=(await t.get(`http://localhost:${r}/meta`)).data;o=o.filter((t=>t.name!==e.name&&!("theme"===e.type&&"theme"===t.type))),window.TopWritePlugins[e.name]&&delete window.TopWritePlugins[e.name],o.unshift(e),sessionStorage.setItem("PLUGIN_DEV",String(r))}catch(e){console.warn(e),sessionStorage.removeItem("PLUGIN_DEV")}}}catch{}const i=Object.entries(window.TopWritePlugins).filter((e=>{let[,t]=e;return!!t.meta})).map((e=>{let[,t]=e;return t.meta})),s=i.some((e=>"theme"===e.type)),a=Object.keys(window.TopWritePlugins),c=[];for(let e of o)e.disabled||a.includes(e.name)||s&&"theme"===e.type||c.push(te(e));return await Promise.all(c),i.push(...o),window.TopWritePluginsMeta=i,Object.values(window.TopWritePlugins||{})}(r,a),l=new Ie(n,r,i);return l.registerModels(o),await l.registerPlugins(c),await l.createApp(s)}function Te(e){return D(e)}function Me(e){return C(e)}function ze(e){return[Me(e),Te(e)]}function je(e){const t=w(null),[n,r]=m(e);p((()=>{t.current&&(t.current(),t.current=null)}),[n]);return[n,(e,n)=>{t.current="function"==typeof n?n:null,r(e)}]}function Le(){const e=document.currentScript;if(!e)throw new Error("Automatic publicPath is not supported in this browser");return e.src.replace(/#.*$/,"").replace(/\?.*$/,"").replace(/\/[^\/]+$/,"/")}class Ae{constructor(e){let{name:t,meta:n,models:r={},components:o={},activate:i,register:s,localize:a,config:c}=e;k(this,"name",void 0),k(this,"config",void 0),k(this,"localize",void 0),k(this,"models",void 0),k(this,"components",void 0),k(this,"activate",void 0),k(this,"register",void 0),k(this,"meta",void 0),this.name=t,this.meta=n,this.models=r,this.components=o,this.activate=i,this.register=s,this.localize=a,this.config=c}}const _e=F("root"),Oe=F("element"),Ue=F("text");function Ne(e){return e.filter((e=>!(Ue(e)&&"\n"===e.value)))}function We(e,t,n){const r=t.properties,o=t.tagName,i={...r};n.prefix&&(n.key++,i.key=n.prefix+n.key);const s=[],a=Ne(t.children),c=a?a.length:0;let l=-1;for(;++l<c;){const t=a[l];Oe(t)?s.push(We(e,t,n)):Ue(t)&&s.push(t.value)}return e.call(t,o,i,s.length>0?s:void 0)}function He(e,t){let{extensions:n=[],creator:r=a.createElement}=t;const o={allowDangerousHtml:!1,handlers:{...n.reduce(((e,t)=>Object.assign(e,t)),{}),textDirective:(e,t)=>e({},"textDirective",{name:t.name,attributes:t.attributes},q(e,t)),leafDirective:(e,t)=>e({},"leafDirective",{name:t.name,attributes:t.attributes},q(e,t)),containerDirective(e,t){"children"in t||(t.children=[]);let n=!1;for(const e of t.children)if(e.data?.directiveLabel){n=!0;break}return n||t.children.unshift({type:"paragraph",children:[{type:"text",value:""}]}),e({},"containerDirective",{name:t.name,attributes:t.attributes},q(e,t))},heading(e,t){const n=e(t,"heading",q(e,t));return n.properties={...n.properties,depth:t.depth},n}},unknownHandler:()=>null},i=B(e,o);if(_e(i))return Ne(i.children).map(((e,t)=>Oe(e)?We(r,e,{key:0,prefix:`h-${t}-`}):Ue(e)?e.value:void 0));if(!Oe(i))throw new Error("Expected root or element, not `"+(i&&i.type||i)+"`");return We(r,i,{key:0,prefix:"h-"})}const qe=e=>{let{value:t}=e;return o("pre",{children:o("code",{children:t})})},Be=e=>{let{value:t}=e;return o("code",{children:t})};const Fe=g({}),Re=Fe.Provider,Ve=()=>v(Fe);function Ge(e,t){return Ve()[e]||t}const Je=["video","audio"];function Ke(e){const{name:t,attributes:n,children:r}=e;let i=Ge(t),s=`html:${t}`;return customElements.get(`t-${t}`)?i=i||`t-${t}`:Je.includes(t)||(i=void 0,s=`directive:${t}`),o(Z,{role:s,props:{...n,children:r},component:i})}function Qe(e){let{depth:t=5,...n}=e;return h(`h${t}`,n)}const Xe={"x-inline":function(e){const{name:t,value:n}=e;return o(Z,{role:`inline:${t}`,props:{type:"inline",name:t,value:n},component:Be})},"x-block":function(e){const{name:t,value:n,parameter:r}=e;return o(Z,{role:`block:${t}`,props:{type:"block",name:t,parameter:r,value:n},component:qe})},textDirective:Ke,leafDirective:Ke,containerDirective:function(e){let{name:t,attributes:n,children:r}=e,i=Ge(t),s=`html:${t}`;const[a,...c]=b.toArray(r),l={children:c,label:a,...n};return customElements.get(`t-${t}`)?i=i||`t-${t}`:Je.includes(t)||(i=void 0,s=`directive:${t}`),o(Z,{role:s,props:l,component:i})},heading:function(e){const t=Ge("heading",Qe);return o(Z,{role:"html:heading",props:e,component:t})}};var Ye={};function Ze(e,t,n){var r,o,i,s,a,c="";for("string"!=typeof t&&(n=t,t=Ze.defaultChars),void 0===n&&(n=!0),a=function(e){var t,n,r=Ye[e];if(r)return r;for(r=Ye[e]=[],t=0;t<128;t++)n=String.fromCharCode(t),/^[0-9a-z]$/i.test(n)?r.push(n):r.push("%"+("0"+t.toString(16).toUpperCase()).slice(-2));for(t=0;t<e.length;t++)r[e.charCodeAt(t)]=e[t];return r}(t),r=0,o=e.length;r<o;r++)if(i=e.charCodeAt(r),n&&37===i&&r+2<o&&/^[0-9a-f]{2}$/i.test(e.slice(r+1,r+3)))c+=e.slice(r,r+3),r+=2;else if(i<128)c+=a[i];else if(i>=55296&&i<=57343){if(i>=55296&&i<=56319&&r+1<o&&(s=e.charCodeAt(r+1))>=56320&&s<=57343){c+=encodeURIComponent(e[r]+e[r+1]),r++;continue}c+="%EF%BF%BD"}else c+=encodeURIComponent(e[r]);return c}Ze.defaultChars=";/?:@&=+$,-_.!~*'()#",Ze.componentChars="-_.!~*'()";var et=Ze,tt={};function nt(e,t){var n;return"string"!=typeof t&&(t=nt.defaultChars),n=function(e){var t,n,r=tt[e];if(r)return r;for(r=tt[e]=[],t=0;t<128;t++)n=String.fromCharCode(t),r.push(n);for(t=0;t<e.length;t++)r[n=e.charCodeAt(t)]="%"+("0"+n.toString(16).toUpperCase()).slice(-2);return r}(t),e.replace(/(%[a-f0-9]{2})+/gi,(function(e){var t,r,o,i,s,a,c,l="";for(t=0,r=e.length;t<r;t+=3)(o=parseInt(e.slice(t+1,t+3),16))<128?l+=n[o]:192==(224&o)&&t+3<r&&128==(192&(i=parseInt(e.slice(t+4,t+6),16)))?(l+=(c=o<<6&1984|63&i)<128?"��":String.fromCharCode(c),t+=3):224==(240&o)&&t+6<r&&(i=parseInt(e.slice(t+4,t+6),16),s=parseInt(e.slice(t+7,t+9),16),128==(192&i)&&128==(192&s))?(l+=(c=o<<12&61440|i<<6&4032|63&s)<2048||c>=55296&&c<=57343?"���":String.fromCharCode(c),t+=6):240==(248&o)&&t+9<r&&(i=parseInt(e.slice(t+4,t+6),16),s=parseInt(e.slice(t+7,t+9),16),a=parseInt(e.slice(t+10,t+12),16),128==(192&i)&&128==(192&s)&&128==(192&a))?((c=o<<18&1835008|i<<12&258048|s<<6&4032|63&a)<65536||c>1114111?l+="����":(c-=65536,l+=String.fromCharCode(55296+(c>>10),56320+(1023&c))),t+=9):l+="�";return l}))}nt.defaultChars=";/?:@&=+$,#",nt.componentChars="";var rt=et;const ot=e=>{let{tagName:t,inject:n=!0,...r}=e;const i=Ge(t,t);return n?Xe[t]?h(Xe[t],r):R.includes(t)?o(Z,{role:`html:${t}`,props:r,component:i}):(console.warn(`unknown tagName: ${t}`),null):h(i,r)};function it(e){let{as:t=l,children:r,components:a={},aside:c=!0,header:d,footer:m,css:p,sectionAs:f,inject:g=!0,...v}=e;const w=u((()=>n().use(H).freeze()),[]),[b,y]=u((()=>{try{const e=w.data("toHastExtensions"),t=w.runSync(w.parse(r));let n=null;if(c){const r=W(t).map;r&&(n=He(r,{extensions:[...e,{link:(e,t)=>{const n=V(t.children);return e(t,"a",{href:rt(t.url)},[{type:"text",value:n}])}}]})),"object"==typeof c&&(n=s(i,{children:[c.header,n,c.footer]}))}const o=He(t,{extensions:e,creator:(e,t,n)=>h(ot,{...t,tagName:e,inject:g},n)});return[o,n]}catch(e){return console.log(e),[null,null]}}),[r,c,w,g]);return h(t,v,s(Re,{value:a,children:[s("article",{children:[d,o(st,{$css:p,as:f,children:b}),m]}),y&&o("aside",{children:y})]}))}const st=j.section`
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  line-height: 1.2;
  word-wrap: break-word;

  & > *:first-child {
    margin-top: 0 !important;
  }

  & > *:last-child {
    margin-bottom: 0 !important;
  }

  h1, h2, h3, h4, h5, h6, p, ul, ol, blockquote, pre, table, audio, video {
    margin: 1em 0;
    line-height: 1.2;
    padding: 0;

    &:last-child {
      margin-bottom: 0 !important;
    }

    &:first-child {
      margin-top: 0 !important;
    }
  }

  p {
    margin: 0;
    line-height: 2;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: normal;

    &.align-right {
      text-align: right;
    }

    &.align-center {
      text-align: center;
    }
  }

  h1 {
    font-size: 2em;
    line-height: 1.2;
    border-bottom: 1px solid #eeeeee;
    padding-bottom: .5em;
  }

  h2 {
    padding-bottom: .4em;
    font-size: 1.3em;
    line-height: 1.2;
    border-bottom: 1px solid #eeeeee
  }

  h3 {
    font-size: 1.2em;
    line-height: 1.2;
  }

  h4 {
    font-size: 1.1em;
    line-height: 1.2;
  }

  h5 {
    font-size: 1em;
    line-height: 1.2;
  }

  hr {
    border: 0;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 0.5em;
  }

  ul {
    padding-left: 2em;

    ul {
      margin: 0;
    }
  }

  ol {
    padding-left: 2em;
  }

  li {
    line-height: 2;

    &.task-list-item {
      list-style: none;
      position: relative;

      input[type=checkbox] {
        position: absolute;
        left: -1.5em;
        top: 0.5em;
        width: 1em;
        height: 1em;
      }
    }

    &.align-right {
      text-align: right;
    }

    &.align-center {
      text-align: center;
    }
  }

  code {
    display: inline-block;
    border-radius: 4px;
    padding: .2em .4em;
    background-color: #f7f7f7;
    word-break: break-all;
    font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    white-space: pre;
    line-height: 1.3;
    color: inherit;
    font-size: inherit;
    margin: -.2em .4em;
  }

  pre {
    padding: 1.05em;
    overflow: auto;
    line-height: 1.45;
    background-color: #f7f7f7;
    border: 0;
    border-radius: 3px;
    font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    font-size: inherit;
  }


  pre > code {
    display: inline;
    max-width: 100%;
    padding: 0;
    margin: 0;
    overflow: initial;
    line-height: inherit;
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    tab-size: 4;
  }

  p {
    &.align-right {
      text-align: right;
    }

    &.align-center {
      text-align: center;
    }
  }

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    line-height: 1.8;
    border-spacing: 0;

    th {
      text-align: left;

      &[align='center'] {
        text-align: center;
      }

      &[align='right'] {
        text-align: right;
      }
    }

    th, td {
      border: 1px solid #e0e0e0;
      padding: 3px 12px;
      height: 34px;
    }

    tr:hover td {
      background-color: #f1f1f1;
    }
  }

  img {
    max-width: 100%;
    display: inline-block;
    padding: 3px;
    vertical-align: middle;
  }

  a {
    text-decoration: none;
    color: var(--ttw-primary-color, #3c60ff);

    &:hover {
      text-decoration: underline;
    }
  }

  blockquote {
    padding: 5px 5px 5px 15px;
    color: #777777;
    border-left: 4px solid #dddddd;

    &.info {
      border-left-color: #5bc0de;
      color: #5bc0de;
      background-color: #f4f8fa;
    }

    &.warning {
      background-color: #fcf8f2;
      border-color: #f0ad4e;
      color: #f0ad4e;
    }

    &.danger {
      color: #d9534f;
      background-color: #fdf7f7;
      border-color: #d9534f;
    }

    &.success {
      background-color: #f3f8f3;
      border-color: #50af51;
      color: #50af51;
    }
  }

  video {
    display: block;
    width: 100%;
  }

  audio {
    display: block;
    width: 100%;
  }

  html[data-theme=dark] & {
    code {
      background-color: #333437;
    }

    pre {
      background-color: #333437;
    }

    h1, h2, hr {
      border-color: #404040;
    }

    th, td {
      border-color: #404040;
    }

    tr:hover td {
      background-color: #333437;
    }
  }

  ${e=>e.$css}
`;function at(e){let{root:t,children:n}=e;return G.createPortal(n,t)}const ct=y(((e,t)=>{let{children:n}=e;const[r,i]=m(null);x(t,(()=>r),[r]);const s=f((e=>{if(e){const t=e.attachShadow({mode:"open"});i(t)}else i(null)}),[i]);return o("div",{ref:s,style:{all:"initial"},children:r&&o(A,{target:r,children:o(at,{root:r,children:n})})})}));function lt(e){const t=w();return p((()=>{t.current=e}),[e]),t.current}function dt(e){const t=w(e);p((()=>(document.title=e,()=>{document.title=t.current})),[e])}function ut(e,t,n){const r=w(e),o=w(M(e,t,n));return p((()=>{r.current=e})),p((()=>{o.current=M((function(){r.current(...arguments)}),t,n)}),[t,n]),o.current}function ht(e,t,n){const r=w(e),o=w(z(e,t,n));return p((()=>{r.current=e})),p((()=>{o.current=z((function(){r.current(...arguments)}),t,n)}),[t,n]),o.current}function mt(){return C("options")}const pt=new EventTarget;function ft(){return pt}function gt(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";const[n,r]=m((()=>window.localStorage.getItem(e)||t)),o=f((t=>{r(t),window.localStorage.setItem(e,t)}),[r,e]);p((()=>{const o=window.localStorage.getItem(e);n!==o&&r(o||t)}));const i=f((o=>{o.key===e&&o.newValue!==n&&r(o.newValue||t)}),[n]);return p((()=>(window.addEventListener("storage",i),()=>window.removeEventListener("storage",i))),[i]),[n,o]}function vt(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.document;if("string"==typeof e){e=(new DOMParser).parseFromString(e,"text/html")}const t=e.querySelector('script[type="application/payload+json"]');if(t)try{return JSON.parse(t.innerHTML)}catch{return{}}}var wt=Object.freeze({__proto__:null,encode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return window.btoa(unescape(encodeURIComponent(e)))}catch(e){if(t)throw e;return""}},decode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return decodeURIComponent(escape(window.atob(e)))}catch(e){if(t)throw e;return""}}});function bt(){return"undefined"!=typeof window&&/Mac|iPod|iPhone|iPad/.test(window.navigator.platform)}const yt="1.0.0";export{Z as InjectedComponent,ee as InjectedComponentSet,$e as LocalizeProvider,it as Markdown,Ae as Plugin,ct as ShadowView,yt as VERSION,wt as base64,Pe as createApplication,ne as createComponentDescriptor,se as createStorageSlot,vt as getPayload,Le as getPublicPath,bt as isMac,ae as listStorageKeys,Te as useActions,xe as useAsyncEffect,ce as useBook,ut as useDebounce,dt as useDocumentTitle,ft as useEventTarget,Se as useIntlContext,gt as useLocalStorageState,ze as useModel,mt as useOptions,lt as usePrevious,Me as useSelector,je as useStateWithCallback,le as useThemeConfig,ge as useThemeContext,ht as useThrottle};
//# sourceMappingURL=index.js.map
